<template>
  <q-dialog
    content-class="detailDialog"
    :value="show"
    persistent
    position="bottom"
  >
    <q-card class="no-border-radius detailCard">
      <q-card-section class="q-pa-none">
        <q-banner dense inline-actions class="q-px-md q-py-md">
          <span class="font-size-14 text-weight-bolder">
            {{ $t('details.selectVariant') }}
          </span>
          <template #action>
            <q-btn size="xs" unelevated round flat @click="$emit('close')">
              <q-icon size="16px" name="font:dm-close" />
            </q-btn>
          </template>
        </q-banner>
      </q-card-section>
      <q-card-section class="q-pa-none">
        <Modifiler v-model="params" :original="modifiers" />
      </q-card-section>
      <q-card-section class="confirm">
        <q-btn
          unelevated
          no-caps
          class="full-width border-radius-8"
          color="primary"
          :label="$t('details.saveChanges')"
          @click="handleConfirm"
        />
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<script>
import _ from 'lodash';
import Modifiler from './Modifiler.vue';

export default {
  components: { Modifiler },
  model: {
    prop: 'show',
    event: 'close',
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    modifiers: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      params: [],
      detail: [],
    };
  },
  watch: {
    modifiers: {
      handler(val) {
        if (!_.isEmpty(val)) {
          this.detail = _.cloneDeep(val);
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    handleConfirm() {
      this.params.forEach((item, index) => {
        this.detail[index].value = item;
      });
      const isPass = this.checkRequired(this.detail);
      if (isPass) {
        this.$emit('getParams', this.params);
        this.$emit('close');
      }
    },
    checkRequired(modifiers) {
      let Switch = true;
      for (let i = 0; i < modifiers.length; i += 1) {
        if (modifiers[i].min) {
          if (_.isEmpty(modifiers[i].value)) {
            this.getErrTips(modifiers[i].name, modifiers[i].min);
            Switch = false;
            break;
          }
          const isArray = Array.isArray(modifiers[i].value);
          if (isArray && modifiers[i].value.length < modifiers[i].min) {
            this.getErrTips(modifiers[i].name, modifiers[i].min);
            Switch = false;
            break;
          }
        }
      }
      return Switch;
    },
    getErrTips(name, min) {
      this.$q.notify({
        message: this.$t('details.verifyRequired', { name, min }),
        spinner: false,
        position: 'bottom',
        classes: 'glossy',
        type: 'ongoing',
        timeout: 1500,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.detailDialog {
  .detailCard {
    background: #f3f4f6;
    position: relative;
    padding-bottom: 60px;
  }
  .confirm {
    background: #f3f4f6;
    padding: 12px 16px;
    position: fixed;
    width: 100%;
    bottom: 0;
    left: 0;
    // 双数高度 会突然出现类似边框的莫名奇妙的东西 单数就消失了 淦
    height: 59px;
  }
}
</style>
